<section class="elegibilidade" aria-labelledby="rentabilidade-titulo" data-testid="beneficios-rentabilidade">
  <header class="elegibilidade__topo">
    <span class="elegibilidade__icone" aria-hidden="true">
      <vivest-icon name="bar-chart-2" source="feather"></vivest-icon>
    </span>
    <div class="elegibilidade__titulo-grupo">
      <h2 id="rentabilidade-titulo" class="elegibilidade__titulo">Rentabilidade</h2>
      <p class="elegibilidade__descricao">Configure a faixa de rentabilidade do plano. Vale para todos os benefícios.</p>
    </div>
  </header>

  @if (carregou()) {
    <div class="elegibilidade__blocos">
      <section class="elegibilidade-parametros" aria-labelledby="rentabilidade-parametros-titulo">
        <div class="elegibilidade-parametros__cabecalho">
          <h3 id="rentabilidade-parametros-titulo" class="elegibilidade__subtitulo">
            Parâmetros de Rentabilidade{{ nomePlano() ? ': ' : '' }}
            @if (nomePlano()) {
              <span class="elegibilidade-parametros__beneficio" data-testid="rentabilidade-plano">{{ nomePlano() }}</span>
            }
          </h3>
        </div>

        <form
          class="elegibilidade-regras"
          novalidate
          [formGroup]="form"
          (submit)="$event.preventDefault(); salvar()"
          data-testid="rentabilidade-form"
        >
          <fieldset class="elegibilidade-bloco" aria-labelledby="rentabilidade-bloco-faixa" data-testid="rentabilidade-bloco-faixa">
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="rentabilidade-bloco-faixa" class="elegibilidade-bloco__titulo">
                Faixa de rentabilidade
              </h4>
              <p class="elegibilidade-bloco__regra">Percentual mínimo e máximo de rentabilidade do plano.</p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <p class="elegibilidade-frase" data-testid="rentabilidade-frase">
                <span>De</span>
                <input
                  type="number"
                  inputmode="decimal"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="0"
                  aria-label="Percentual mínimo de rentabilidade"
                  class="form-control campanha-form-control elegibilidade-frase__numero"
                  formControlName="percentualMinimo"
                  [class.is-invalid]="!!erro()"
                  data-testid="rentabilidade-minimo"
                />
                <span>% a</span>
                <input
                  type="number"
                  inputmode="decimal"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="0"
                  aria-label="Percentual máximo de rentabilidade"
                  class="form-control campanha-form-control elegibilidade-frase__numero"
                  formControlName="percentualMaximo"
                  [class.is-invalid]="!!erro()"
                  data-testid="rentabilidade-maximo"
                />
                <span>%</span>
              </p>
              @if (erro(); as mensagem) {
                <p class="elegibilidade__erro" role="alert" data-testid="rentabilidade-erro">{{ mensagem }}</p>
              }
            </div>
          </fieldset>

          <fieldset class="elegibilidade-bloco" aria-labelledby="rentabilidade-bloco-padrao" data-testid="rentabilidade-bloco-padrao">
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="rentabilidade-bloco-padrao" class="elegibilidade-bloco__titulo">
                Valor padrão
              </h4>
              <p class="elegibilidade-bloco__regra">Percentual de rentabilidade padrão, dentro da faixa.</p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <p class="elegibilidade-frase">
                <input
                  type="number"
                  inputmode="decimal"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="0"
                  aria-label="Percentual padrão de rentabilidade"
                  class="form-control campanha-form-control elegibilidade-frase__numero"
                  formControlName="percentualPadrao"
                  [class.is-invalid]="!!erroPadrao()"
                  data-testid="rentabilidade-padrao"
                />
                <span>%</span>
              </p>
              @if (erroPadrao(); as mensagem) {
                <p class="elegibilidade__erro" role="alert" data-testid="rentabilidade-padrao-erro">{{ mensagem }}</p>
              }
            </div>
          </fieldset>
        </form>
      </section>

      <aside class="elegibilidade-resumo" aria-labelledby="rentabilidade-resumo-titulo" data-testid="rentabilidade-resumo">
        <h3 id="rentabilidade-resumo-titulo" class="elegibilidade-resumo__titulo">Resumo{{ nomePlano() ? ' (' + nomePlano() + ')' : '' }}</h3>
        <ul class="elegibilidade-resumo__itens" data-testid="rentabilidade-resumo-itens">
          @for (item of resumo(); track $index) {
            <li>{{ item }}</li>
          }
        </ul>
      </aside>
    </div>

    <footer class="elegibilidade__rodape">
      @if (temAlteracoes()) {
        <span class="elegibilidade__pendente" data-testid="rentabilidade-alteracoes-pendentes">Há alterações não salvas</span>
      }
      <vivest-button variant="outline" size="md" [disabled]="!temAlteracoes()" data-testid="rentabilidade-cancelar" (click)="descartar()">
        Cancelar
      </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!temAlteracoes()" data-testid="rentabilidade-salvar" (click)="salvar()">
        <vivest-icon slot="icon-left" name="save" source="feather"></vivest-icon>
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  }
</section>

<vivest-modal
  heading="Salvar rentabilidade"
  description="A faixa e o valor padrão de rentabilidade passam a valer para todos os benefícios do plano. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="confirmandoSalvar.set(false)"
  data-testid="rentabilidade-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="rentabilidade-confirmar-voltar" (click)="confirmandoSalvar.set(false)">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="rentabilidade-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
